import DateRangePicker from 'components/commons/date-range-picker'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import { Button } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import Graph from 'components/commons/graph'
import { INITIAL_DATA_FILTER, SORT_REVENUE, TABLE_PER_DAY } from 'configs/analytics/configTableRevenue'
import { RevenueComparison } from 'components/analytics/revenue/revenue-comparison/RevenueComparison'
import PageLimit from 'components/commons/page-limit'
import Sort from 'components/commons/sort'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import moment from 'moment'
import { useRef } from 'react'

export const Revenue = ({
    dataComparison,
    dataGraph,
    dataList,
    query,
    onChangeQuery,
    onSelectSort,
    showModalExport,
    setShowModalExportHandler,
    isLoadingComparison,
    isLoadingGraph,
    isLoadingList,
    isLoadingExport,
    onExport,
}) => {
    const listRef = useRef()
    const initDate = [INITIAL_DATA_FILTER?.startDate, INITIAL_DATA_FILTER?.endDate]

    const onChangePage = (value) => {
        listRef.current?.scrollIntoView()
        onChangeQuery(value)
    }

    return (
        <div className={'flex flex-col gap-y-5 px-9 py-5'}>
            <div className={'flex space-x-3'}>
                <DateRangePicker
                    value={query?.startDate ? [query?.startDate, query?.endDate] : initDate}
                    onChange={(value) =>
                        onChangeQuery({
                            ...INITIAL_DATA_FILTER,
                            startDate: value[0] || initDate[0],
                            endDate: value[1] || initDate[1],
                        })
                    }
                    maxDate={moment()}
                    format={'YYYY-MM-DD'}
                />
                <Button
                    title={'Export'}
                    icon={icLinkExternal}
                    type={'outline'}
                    disabled={!dataList?.total_result}
                    onClick={() => setShowModalExportHandler(true)}
                />
            </div>
            <RevenueComparison dataComparison={dataComparison} isLoading={isLoadingComparison} />
            <TabToggle
                title={'Revenue Graph'}
                isLoading={isLoadingGraph}
                content={<Graph title={'Revenue'} name={'revenue'} values={dataGraph || {}} />}
            />
            <TabToggle
                title={'Revenue Per Day'}
                content={
                    <div ref={listRef} className={'overflow-auto'}>
                        <div className={'flex space-x-3'}>
                            <PageLimit
                                value={query?.limit}
                                onSelect={(value) => onChangeQuery({ limit: value, page: 1 })}
                            />
                            <Sort
                                options={SORT_REVENUE}
                                value={`${query?.orderBy}_${query?.orderType}`}
                                onSelect={(value) => onSelectSort(value)}
                            />
                        </div>
                        <div>
                            <Table
                                className={'my-3'}
                                name={TABLE_PER_DAY.name}
                                columns={TABLE_PER_DAY.column}
                                data={dataList?.result}
                                size={query?.limit}
                                currentPage={query?.page}
                                totalPage={dataList?.total_page}
                                totalResult={dataList?.total_result}
                                onChangePage={(val) => onChangePage({ page: val })}
                                loading={isLoadingList}
                            />
                        </div>
                    </div>
                }
            />
            {showModalExport && (
                <ModalExport
                    show={showModalExport}
                    onHide={() => setShowModalExportHandler(false)}
                    description={'Are You Sure Export This?'}
                    totalData={dataList?.total_result}
                    isLoading={isLoadingExport}
                    onExport={onExport}
                />
            )}
        </div>
    )
}
